import React from 'react'

import { Field } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Col, Button } from '_zari/core'

import * as SocioCrud from 'services/socio.service'

import CrudPlacasModal from './modals/crudPlacas'

const PlacaSocioFormGroup = ({ iValue_IdSocio, iError, iTouched, fIsSubmitting, setFieldValue, flagEditarComentarios, flagGrifo }) => {
  const __zariContext = React.useContext(ZariContext)

  const [placas, setPlacas] = React.useState([])
  const [mostrarCrudPlacasModal, setMostrarCrudPlacasModal] = React.useState(false)

  React.useEffect(() => {
    if (iValue_IdSocio === '') {
      setPlacas([])
      setFieldValue('_idPlacaSocio', '')
    } else {
      SocioCrud.obtenerPlacasxIdSocioAsSelect(iValue_IdSocio)
        .then(({ data }) => {
          setPlacas(data)
          if (data.length === 1) {
            setFieldValue('_idPlacaSocio', data[0]._id)
          }
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    }
  }, [iValue_IdSocio, __zariContext, setFieldValue])

  const clickMostrarCrudPlacasModalHandler = e => {
    e.preventDefault()
    setMostrarCrudPlacasModal(true)
  }

  const refrescarListaPlacasHandler = React.useCallback(() => {
    SocioCrud.obtenerPlacasxIdSocioAsSelect(iValue_IdSocio)
      .then(({ data }) => {
        setPlacas(data)
        if (data.length === 1) {
          setFieldValue('_idPlacaSocio', data[0]._id)
        } else {
          setFieldValue('_idPlacaSocio', '')
        }
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [iValue_IdSocio, __zariContext, setFieldValue])

  return (
    <>
      <Form.Group>
        <Form.Label text='PLACA' htmlFor='select-idPlacaSocio' md={flagGrifo ? 6 : 4} alignRightAt='md' />
        <Col md={flagGrifo ? 6 : 8}>
          <Form.InputGroup>
            <Field name='_idPlacaSocio'>
              {({ field }) => (
                <Form.Select
                  {...field}
                  id='select-idPlacaSocio'
                  isInvalid={iTouched && iError}
                  disabled={fIsSubmitting || iValue_IdSocio === '' || flagEditarComentarios}
                >
                  <option value=''>Seleccionar</option>
                  {placas.map((val, key) => (
                    <option key={key} value={val._id}>
                      {val.placa}
                    </option>
                  ))}
                </Form.Select>
              )}
            </Field>
            {!flagEditarComentarios && (
              <Form.InputGroup.Append>
                <Button disabled={fIsSubmitting || iValue_IdSocio === ''} onClick={clickMostrarCrudPlacasModalHandler}>
                  &#x2b;
                </Button>
              </Form.InputGroup.Append>
            )}
            {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
          </Form.InputGroup>
        </Col>
      </Form.Group>
      {mostrarCrudPlacasModal && (
        <CrudPlacasModal
          handleClose={e => setMostrarCrudPlacasModal(false)}
          show={mostrarCrudPlacasModal}
          _idSocio={iValue_IdSocio}
          refrescarListaPlacasHandler={refrescarListaPlacasHandler}
        />
      )}
    </>
  )
}

export default React.memo(PlacaSocioFormGroup)
